import React from "react";

/**
 * Standard card used across the employee profile subtabs.
 * `header` may be a plain string (rendered as a section title) or a custom node
 * (e.g. a grid of table column labels). Pass `bodyClassName="p-0"` for cards
 * whose content manages its own padding (tables, divided lists).
 */
function EmployeeProfileSectionCard({
  header,
  children,
  bodyClassName = "p-6",
  className = "",
}) {
  return (
    <div
      className={`bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden ${className}`}
    >
      {header != null && header !== false && (
        <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
          {typeof header === "string" ? (
            <h3 className="text-sm font-semibold text-gray-900">{header}</h3>
          ) : (
            header
          )}
        </div>
      )}
      {children != null && <div className={bodyClassName}>{children}</div>}
    </div>
  );
}

export default EmployeeProfileSectionCard;
